export const commonHeaderDropdown = [
  {
    label: `Login`,
  },
];

export const signedInHeaderDropdown = [
  {
    label: `My Profile`,
  },
  {
    label: `Settings`,
  },
  {
    label: `Help`,
  }
];

export const commonHeaderTabs = [
  {
    label: `Home`,
  },
  {
    label: `Calendar`,
  },
  {
    label: `Job Board`,
  },
];
